/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiLoginCheckLoginPost } from '../fn/login/api-login-check-login-post';
import { ApiLoginCheckLoginPost$Params } from '../fn/login/api-login-check-login-post';
import { apiLoginCheckLoginPost$Plain } from '../fn/login/api-login-check-login-post-plain';
import { ApiLoginCheckLoginPost$Plain$Params } from '../fn/login/api-login-check-login-post-plain';
import { apiLoginGetUserDataGet } from '../fn/login/api-login-get-user-data-get';
import { ApiLoginGetUserDataGet$Params } from '../fn/login/api-login-get-user-data-get';
import { apiLoginGetUserDataGet$Plain } from '../fn/login/api-login-get-user-data-get-plain';
import { ApiLoginGetUserDataGet$Plain$Params } from '../fn/login/api-login-get-user-data-get-plain';
import { apiLoginListLanguagesGet } from '../fn/login/api-login-list-languages-get';
import { ApiLoginListLanguagesGet$Params } from '../fn/login/api-login-list-languages-get';
import { apiLoginListLanguagesGet$Plain } from '../fn/login/api-login-list-languages-get-plain';
import { ApiLoginListLanguagesGet$Plain$Params } from '../fn/login/api-login-list-languages-get-plain';
import { apiLoginLogoutGet } from '../fn/login/api-login-logout-get';
import { ApiLoginLogoutGet$Params } from '../fn/login/api-login-logout-get';
import { Language as UserServiceContractLanguage } from '../models/UserService/Contract/language';
import { LoginResponse as UserServiceContractLoginResponse } from '../models/UserService/Contract/login-response';

@Injectable({ providedIn: 'root' })
export class LoginService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiLoginCheckLoginPost()` */
  static readonly ApiLoginCheckLoginPostPath = '/api/Login/CheckLogin';

  /**
   * Login verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginCheckLoginPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoginCheckLoginPost$Plain$Response(params?: ApiLoginCheckLoginPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UserServiceContractLoginResponse>> {
    return apiLoginCheckLoginPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Login verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginCheckLoginPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoginCheckLoginPost$Plain(params?: ApiLoginCheckLoginPost$Plain$Params, context?: HttpContext): Observable<UserServiceContractLoginResponse> {
    return this.apiLoginCheckLoginPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserServiceContractLoginResponse>): UserServiceContractLoginResponse => r.body)
    );
  }

  /**
   * Login verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginCheckLoginPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoginCheckLoginPost$Response(params?: ApiLoginCheckLoginPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UserServiceContractLoginResponse>> {
    return apiLoginCheckLoginPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Login verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginCheckLoginPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoginCheckLoginPost(params?: ApiLoginCheckLoginPost$Params, context?: HttpContext): Observable<UserServiceContractLoginResponse> {
    return this.apiLoginCheckLoginPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserServiceContractLoginResponse>): UserServiceContractLoginResponse => r.body)
    );
  }

  /** Path part for operation `apiLoginLogoutGet()` */
  static readonly ApiLoginLogoutGetPath = '/api/Login/Logout';

  /**
   * Exit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginLogoutGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginLogoutGet$Response(params?: ApiLoginLogoutGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiLoginLogoutGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Exit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginLogoutGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginLogoutGet(params?: ApiLoginLogoutGet$Params, context?: HttpContext): Observable<void> {
    return this.apiLoginLogoutGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiLoginGetUserDataGet()` */
  static readonly ApiLoginGetUserDataGetPath = '/api/Login/GetUserData';

  /**
   * Getting the data of the current registered user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginGetUserDataGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginGetUserDataGet$Plain$Response(params?: ApiLoginGetUserDataGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UserServiceContractLoginResponse>> {
    return apiLoginGetUserDataGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the data of the current registered user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginGetUserDataGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginGetUserDataGet$Plain(params?: ApiLoginGetUserDataGet$Plain$Params, context?: HttpContext): Observable<UserServiceContractLoginResponse> {
    return this.apiLoginGetUserDataGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserServiceContractLoginResponse>): UserServiceContractLoginResponse => r.body)
    );
  }

  /**
   * Getting the data of the current registered user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginGetUserDataGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginGetUserDataGet$Response(params?: ApiLoginGetUserDataGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UserServiceContractLoginResponse>> {
    return apiLoginGetUserDataGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the data of the current registered user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginGetUserDataGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginGetUserDataGet(params?: ApiLoginGetUserDataGet$Params, context?: HttpContext): Observable<UserServiceContractLoginResponse> {
    return this.apiLoginGetUserDataGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserServiceContractLoginResponse>): UserServiceContractLoginResponse => r.body)
    );
  }

  /** Path part for operation `apiLoginListLanguagesGet()` */
  static readonly ApiLoginListLanguagesGetPath = '/api/Login/ListLanguages';

  /**
   * List of available languages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginListLanguagesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginListLanguagesGet$Plain$Response(params?: ApiLoginListLanguagesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserServiceContractLanguage>>> {
    return apiLoginListLanguagesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * List of available languages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginListLanguagesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginListLanguagesGet$Plain(params?: ApiLoginListLanguagesGet$Plain$Params, context?: HttpContext): Observable<Array<UserServiceContractLanguage>> {
    return this.apiLoginListLanguagesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserServiceContractLanguage>>): Array<UserServiceContractLanguage> => r.body)
    );
  }

  /**
   * List of available languages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoginListLanguagesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginListLanguagesGet$Response(params?: ApiLoginListLanguagesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserServiceContractLanguage>>> {
    return apiLoginListLanguagesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * List of available languages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLoginListLanguagesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoginListLanguagesGet(params?: ApiLoginListLanguagesGet$Params, context?: HttpContext): Observable<Array<UserServiceContractLanguage>> {
    return this.apiLoginListLanguagesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserServiceContractLanguage>>): Array<UserServiceContractLanguage> => r.body)
    );
  }

}
